"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var useBulkQuery_1 = require("./useBulkQuery");
Object.defineProperty(exports, "useBulkQuery", { enumerable: true, get: function () { return useBulkQuery_1.default; } });
//# sourceMappingURL=index.js.map